var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewspaper = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.15 6A2.85 2.85 0 0 1 5 3.15h10A2.85 2.85 0 0 1 17.85 6v.15H19A2.85 2.85 0 0 1 21.85 9v9A2.85 2.85 0 0 1 19 20.85H5A2.85 2.85 0 0 1 2.15 18zm14.242 13.15H5A1.15 1.15 0 0 1 3.85 18V6c0-.635.515-1.15 1.15-1.15h10c.635 0 1.15.515 1.15 1.15v12c0 .41.086.798.242 1.15m1.458-11.3V18a1.15 1.15 0 1 0 2.3 0V9A1.15 1.15 0 0 0 19 7.85zM6.15 8c0-.47.38-.85.85-.85h6c.47 0 .85.38.85.85v4c0 .47-.38.85-.85.85H7a.85.85 0 0 1-.85-.85zm1.7.85v2.3h4.3v-2.3zM6.15 16c0-.47.38-.85.85-.85h6a.85.85 0 1 1 0 1.7H7a.85.85 0 0 1-.85-.85",
  clipRule: "evenodd"
})));
export default SvgNewspaper;